<template>
  <v-dialog v-model="dialog" scrollable width="700">
    <v-card v-if="item">
      <v-toolbar color="primary" dense dark class="elevation-0">
        <v-toolbar-title>Chi tiết chứng từ {{ item.code }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-6">
        <v-row dense class="mb-3">
          <v-col cols="6">
            <span class="grey--text">Mã phiếu:</span>
            <strong class="primary--text ml-2">{{ item.code }}</strong>
          </v-col>
          <v-col cols="6">
            <span class="grey--text">Loại phiếu:</span>
            <v-chip x-small :color="getTypeColor(item.type)" dark class="ml-2">
              {{ getTypeLabel(item.type) }}
            </v-chip>
          </v-col>
          <v-col cols="12">
            <span class="grey--text">Tiêu đề:</span>
            <strong class="ml-2">{{ item.title }}</strong>
          </v-col>
          <v-col cols="6">
            <span class="grey--text">Ngày thực hiện:</span>
            <span class="ml-2">{{ item.transactionDate || '-' }}</span>
          </v-col>
          <v-col cols="6">
            <span class="grey--text">Người lập:</span>
            <span class="ml-2">{{ item.performer || '-' }}</span>
          </v-col>
          <v-col cols="6" v-if="item.fromLocation">
            <span class="grey--text">Từ vị trí:</span>
            <span class="ml-2 font-weight-medium">{{ get(item, 'fromLocation.name', '-') }}</span>
          </v-col>
          <v-col cols="6" v-if="item.toLocation">
            <span class="grey--text">Đến vị trí:</span>
            <span class="ml-2 font-weight-medium">{{ get(item, 'toLocation.name', '-') }}</span>
          </v-col>
        </v-row>

        <v-divider class="my-3" />

        <div class="text-subtitle-2 font-weight-bold mb-2">DANH SÁCH THIẾT BỊ</div>
        <v-simple-table dense class="elevation-1">
          <template v-slot:default>
            <thead>
              <tr class="grey lighten-4">
                <th>STT</th>
                <th>Tên thiết bị</th>
                <th class="text-center">Số lượng</th>
                <th class="text-center">Đơn vị</th>
                <th class="text-right">Đơn giá</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(it, idx) in item.items || []" :key="idx">
                <td>{{ idx + 1 }}</td>
                <td>{{ it.assetName || it.asset }}</td>
                <td class="text-center font-weight-bold">{{ it.quantity }}</td>
                <td class="text-center">{{ it.unit || 'Chiếc' }}</td>
                <td class="text-right">{{ (it.price || 0).toLocaleString('vi-VN') }} đ</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <div v-if="item.note" class="mt-4">
          <span class="grey--text">Ghi chú:</span> {{ item.note }}
        </div>
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn outlined @click="dialog = false">ĐÓNG</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { get } from 'lodash'

export default {
  name: 'TransactionDetailDialog',
  props: {
    state: Boolean,
    item: Object
  },
  data() {
    return {
      dialog: false
    }
  },
  watch: {
    state(val) {
      if (val) this.dialog = true
    }
  },
  methods: {
    get,
    getTypeLabel(type) {
      switch (type) {
        case 'IMPORT': return 'Nhập kho'
        case 'EXPORT': return 'Xuất kho'
        case 'TRANSFER': return 'Luân chuyển'
        case 'LIQUIDATION': return 'Thanh lý'
        default: return type
      }
    },
    getTypeColor(type) {
      switch (type) {
        case 'IMPORT': return 'success'
        case 'EXPORT': return 'warning'
        case 'TRANSFER': return 'indigo'
        case 'LIQUIDATION': return 'error'
        default: return 'blue-grey'
      }
    }
  }
}
</script>
